// ** React Imports
import { memo } from 'react'

//Custom Component Imports
import CustomDialog from '../dialog'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Utils Imports
import { formatDateTime } from '../../utils/utils'

const blockQuoteStyle = {
  padding: '0.5rem 1rem',
  borderLeft: '5px solid var(--primary-main)',
  fontStyle: 'italic',
  position: 'relative'
}

const ViewRemarkModal = ({ open, handleClose, data = [] }) => {
  return (
    <CustomDialog
      open={open}
      title={`All Remarks`}
      handleClose={() => handleClose()}
      dialogPaperStyle={{
        width: '80%',
        maxWidth: '1000px'
      }}
    >
      {open && (
        <Box sx={{ gap: '16px', display: 'flex', flexDirection: 'column' }}>
          {data?.length > 0 &&
            data?.map((item) => (
              <blockquote style={blockQuoteStyle} key={item?.id}>
                <Box
                  sx={{ gap: '4px', display: 'flex', flexDirection: 'column' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '8px'
                    }}
                  >
                    <Typography variant="body1" fontWeight={600}>
                      {item?.createdBy}
                    </Typography>
                    <Typography variant="caption">
                      {formatDateTime(item?.createdTimestamp)}
                    </Typography>
                  </Box>
                  <Typography variant="body2" whiteSpace={'pre-line'}>
                    {item?.remarks}
                  </Typography>
                </Box>
              </blockquote>
            ))}
          {data?.length === 0 && <Typography>No Remarks Found</Typography>}
        </Box>
      )}
    </CustomDialog>
  )
}

export default memo(ViewRemarkModal)
